import React,{useState} from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,Row,Col,Label,Input } from 'reactstrap';
import SearchSelectAllUsers from 'components/Reusable Components/SearchSelectAllUsers';
import { checkIn } from 'network/ApiAccomodation';

function CheckInModal(props) {
  const [userId, setUserId] = useState(null);
  const [bedding, setBedding] = useState('');
  const [deposit, setDeposit] = useState(false);
  const [about, setAbout] = useState('');

  const managerId = JSON.parse(localStorage.getItem('user'))._id

  const onSelect = (e)=>{
    setUserId(e.value) 
  }

  const handleCheckIn = async()=>{
    if(userId && bedding){
      const resp = await checkIn(props.room,deposit,userId,about,managerId,bedding)
      if(resp.data.success){
        props.mapReload(props.room)
        props.inToggle()
      }else{
        alert('something went wrong')
      }
    }
  }

  return (
    <Modal isOpen={props.inModal} toggle={props.inToggle}>
        <ModalHeader>Check In</ModalHeader>
        <ModalBody>
            <Label>User:</Label>
            <SearchSelectAllUsers onSelect={onSelect} />
            <Label>Bedding:</Label>
            <Input type='text' onChange={(e)=>setBedding(e.target.value)} />
            <Row className='mb-2'/>
            
            <Label for='deposit' >Deposit:</Label>
            <Input type='checkbox' id='deposit' onChange={(e)=>{setDeposit(e.target.value == 'on' ? true : false)}} className='ml-4' />
            
            <Row/>
            <Label>About:</Label>
            <Input type='text' onChange={(e)=>setAbout(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button onClick={()=>handleCheckIn()}>Check In</Button>
        </ModalFooter>
    </Modal>
  )
}

export default CheckInModal